import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoCondicoesVisualizacao } from 'pages/compra/configuracao-pedido/types';

/**
 * Formata os dados iniciais da tela de condicoes de visualizacao.
 */
export const formatInitialCondicoesVisualizacaoData = (data: ConfigPedidoCondicoesVisualizacao) => {
    const { configPedidoEstados, configPedidoLojas, configPedidoFaixaRoyalties } = data;

    let tpDisponibilizacao = 'lojas';

    if (configPedidoEstados.length > 0) {
        tpDisponibilizacao = 'estados';
    }

    return {
        ...data,
        tpDisponibilizacao,
        configPedidoEstados: configPedidoEstados,
        configPedidoLojas: configPedidoLojas,
        fgLojaFaixaRoyalties: Boolean(configPedidoFaixaRoyalties?.idConfigPedidoFaixaRoyalties),
        configPedidoFaixaRoyalties: configPedidoFaixaRoyalties?.idConfigPedidoFaixaRoyalties ? configPedidoFaixaRoyalties : null,
    };
};

export function useQueryCondicoesVisualizacao() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    return useQuery<ConfigPedidoCondicoesVisualizacao>({
        queryKey: ['config-pedido-condicoes-visualizacao', id],
        queryFn: () =>
            requestListagem({
                url: `/gestao/configpedidocondicaovisualizacao/configpedido/${id}`,
            }).then(({ data }) => formatInitialCondicoesVisualizacaoData(data)),
    });
}
